var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color_picker"},[_c('ul',{staticClass:"colors_list"},_vm._l((_vm.colors),function(color){return _c('li',{key:color,class:{
        color_item: true,
        selected: color === _vm.selected,
      },style:({
        '--background-color': color,
      }),on:_vm._d({},[_vm.EVENTS.CLICK,() => _vm.$emit(_vm.EVENTS.SELECT, color)])})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }